import type { ChartDataInterface } from 'src/types/Chart';

/** Normalize overall energy statistics for DashChartWidget bar variant. */
export const prepareTotalEnergyDashChartData = (chartData: ChartDataInterface): ChartDataInterface => ({
	...chartData,
	type: 'bar',
	chartLayout: 'dashboard-widget',
	height: 220,
	rangePeriod: chartData.rangePeriod ?? '24_hours',
	rangeInterval: chartData.rangeInterval ?? 'hour',
	deviceID: chartData.deviceID ?? chartData.id ?? 'overall-energy',
	id: chartData.id ?? chartData.name ?? 'overall-energy',
});
